import { OktaAuth } from '@okta/okta-auth-js';

/**
 * Singleton to store the OktaAuth instance
 * This allows non-React code to access the auth instance
 */
class OktaAuthStore {
  private instance: OktaAuth | null = null;

  setInstance(oktaAuth: OktaAuth): void {
    this.instance = oktaAuth;
  }

  getInstance(): OktaAuth | null {
    return this.instance;
  }

  getAccessToken(): string | undefined {
    return this.instance?.getAccessToken();
  }
}

export const oktaAuthStore = new OktaAuthStore();
